export const PUBLIC_PATHS = ['/login', '/setup'];

export const ACCOUNT_TYPES = {
  ADMIN: '0489e1b0-e5cc-45bd-a680-04462bc01a9f',
  ADVISORS: '5e5ee165-68f3-443b-ace8-30cf56d41cec',
  PARTICIPANTS: '30a31c92-c05b-47e7-93ae-ec22f7234821'
};

export const INVESTMENT_VEHICLE_CONTRIBUTION_UNIT_TYPES = {
  BOTH: '847ac8f6-8e7e-4da3-9ca2-c63c0477d74f',
  DOLLARS: 'a99f49cd-da55-4bc3-8bc2-04fbddf7ae90',
  PERCENT: 'f72d7799-7e49-4b00-9a73-48ca9994b2a1'
};

export const MANAGED_ACCOUNT_PROVIDERS = {
  BLACK_ROCK: '9fdb1eac-d391-459e-bda7-479f937323af',
  CAP_GROUP: 'ee18ffb0-8ca1-4433-b5f0-0d73e2215bba',
  FINGAGE: 'd42cf4b1-27d1-4e03-bb94-4f54348cbb36',
  FIVE_FUND: 'a1e8d14a-5157-42b1-ab7a-51eeeb737a77',
  FT: '104455ae-09af-11ed-861d-0242ac120002',
  IJOIN_AMA: '79817c0c-ac22-11ec-8222-1bdbbebc11e3',
  LH: '9ced6d96-fa8e-11eb-9a03-0242ac130003',
  PAC_LIFE: '4eb34c4d-f936-4bf3-b34c-4df9367bf334',
  PGIM: '71705099-b093-4081-bab6-020a560543ad',
  PIMCO: 'cf9dc3e8-9b27-44ff-ad97-20c177235b8d',
  PIMCO_WITH_ANNUITY: 'a604a838-d375-4297-9e33-7d4e29c7d98b',
  PIMCO_WITH_PAC_LIFE_INCOME_HORIZON: '5cafeab0-e323-4138-b43f-dfdce9fea5d3',
  PRONVEST: 'de4c20b6-415b-11ec-ba1c-0242ac130002',
  STADION: '6b929e7e-8b3e-11ec-a8a3-0242ac120002',
  TIAA_SIA: 'f1e2d3c4-b5a6-4978-9012-3456789010ab',
  TIAA_SIA_WITH_SRP_GUIDANCE: 'b9d3e4f5-a6c7-4890-b1d2-e3f4a5b6c7d8',
  UT: 'c1711eec-0aba-4ceb-8d0b-e5df8a0a8244'
};

export const MANAGED_ACCOUNT_PROVIDERS_WITHOUT_FUND_CONFIG = new Set([
  MANAGED_ACCOUNT_PROVIDERS.BLACK_ROCK,
  MANAGED_ACCOUNT_PROVIDERS.CAP_GROUP,
  MANAGED_ACCOUNT_PROVIDERS.FINGAGE,
  MANAGED_ACCOUNT_PROVIDERS.FT,
  MANAGED_ACCOUNT_PROVIDERS.IJOIN_AMA,
  MANAGED_ACCOUNT_PROVIDERS.LH,
  MANAGED_ACCOUNT_PROVIDERS.PAC_LIFE,
  MANAGED_ACCOUNT_PROVIDERS.PIMCO_WITH_PAC_LIFE_INCOME_HORIZON,
  MANAGED_ACCOUNT_PROVIDERS.PGIM,
  MANAGED_ACCOUNT_PROVIDERS.PIMCO,
  MANAGED_ACCOUNT_PROVIDERS.PIMCO_WITH_ANNUITY,
  MANAGED_ACCOUNT_PROVIDERS.PRONVEST,
  MANAGED_ACCOUNT_PROVIDERS.STADION,
  MANAGED_ACCOUNT_PROVIDERS.TIAA_SIA,
  MANAGED_ACCOUNT_PROVIDERS.TIAA_SIA_WITH_SRP_GUIDANCE
]);
